/*
 * ATTENTION: The "eval" devtool has been used (maybe by default in mode: "development").
 * This devtool is neither made for production nor for readable output files.
 * It uses "eval()" calls to create a separate source file in the browser devtools.
 * If you are trying to read the output file, select a different devtool (https://webpack.js.org/configuration/devtool/)
 * or disable the default devtool with "devtool: false".
 * If you are looking for production-ready output files, see mode: "production" (https://webpack.js.org/configuration/mode/).
 */
/******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ "./src/snippets/snippet.option-swatch.css":
/*!************************************************!*\
  !*** ./src/snippets/snippet.option-swatch.css ***!
  \************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

eval("{__webpack_require__.r(__webpack_exports__);\n// extracted by mini-css-extract-plugin\n\n\n//# sourceURL=webpack://ardene-theme/./src/snippets/snippet.option-swatch.css?\n}");

/***/ }),

/***/ "./src/snippets/snippet.option-swatch.js":
/*!***********************************************!*\
  !*** ./src/snippets/snippet.option-swatch.js ***!
  \***********************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

eval("{__webpack_require__.r(__webpack_exports__);\n/**\n * Option Swatch Component\n * Handles keyboard accessibility for option swatch selection\n */\n\n// Use event delegation to handle dynamically added elements\ndocument.addEventListener('keydown', (e) => {\n  // Only handle Enter and Space keys\n  if (e.key !== 'Enter' && e.key !== ' ') return;\n\n  // Check if the target is an option swatch label\n  const label = e.target.closest('.option-swatch__label');\n  if (!label) return;\n\n  // Prevent default behavior\n  e.preventDefault();\n  e.stopPropagation();\n\n  const input = label.querySelector('input');\n\n  if (!input || input.disabled) return;\n\n  input.click();\n});\n\n\n//# sourceURL=webpack://ardene-theme/./src/snippets/snippet.option-swatch.js?\n}");

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The require scope
/******/ 	var __webpack_require__ = {};
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module can't be inlined because the eval devtool is used.
/******/ 	__webpack_modules__["./src/snippets/snippet.option-swatch.js"](0, {}, __webpack_require__);
/******/ 	var __webpack_exports__ = {};
/******/ 	__webpack_modules__["./src/snippets/snippet.option-swatch.css"](0, __webpack_exports__, __webpack_require__);
/******/ 	
/******/ })()
;